import tapeFallbackUrl from '../assets/carpe-diem/tape-fallback.jpg'

interface TapeFallbackBackgroundProps {
  /** Task name written on the cassette label. */
  label: string
  className?: string
}

/**
 * Shared blank-cassette art with a handwriting-style title on the cream label.
 * Used on the Hub live board when a deck has no Gemini tape art.
 *
 * Horizontal inset matches LiveWorkCard (px-2.5) + TapeReels (px-24 + inward
 * reel shift), plus side padding so the title clears the hubs.
 */
export function TapeFallbackBackground({ label, className = '' }: TapeFallbackBackgroundProps) {
  const text = label.trim() || 'Untitled'
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden>
      <img
        src={tapeFallbackUrl}
        alt=""
        className="absolute inset-0 h-full w-full object-cover object-center"
        draggable={false}
      />
      <div className="absolute left-0 right-0 top-[38%] bottom-[38%] flex items-center justify-center px-[calc(0.625rem+24px+2*min(22%,2.56rem)-5px+16px)]">
        <p
          className="max-h-full w-full overflow-hidden text-center font-handwriting text-[clamp(0.65rem,2.8vw,1rem)] font-semibold leading-[1.15] text-gray-900 break-words [display:-webkit-box] [-webkit-box-orient:vertical] [-webkit-line-clamp:3] [overflow-wrap:anywhere]"
          title={text}
        >
          {text}
        </p>
      </div>
    </div>
  )
}
